"use client";

import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { resetGithub } from "@/store/githubSlice";
import NavigationHeader from '@/components/home/navigation-header';
import HeroSection from '@/components/home/hero-section';
import PortfolioGrid from '@/components/home/portfolio-grid';
import Footer from '@/components/home/footer';
import { resetSupabase } from "@/store/supabaseSlice";
import { clearLogs } from "@/store/iframeLogSlice";
import { clearAppPreview } from "@/store/appPreviewSlice";

export default function HomePage() {
   const dispatch = useDispatch();

  useEffect(() => {
    // 🧹 Reset GitHub redux when leaving project dashboard and landing here
    dispatch(resetGithub());
    dispatch(resetSupabase());
    dispatch(clearLogs());
    dispatch(clearAppPreview());
  }, [dispatch]);

  return (
     <div className="relative h-screen flex flex-col text-white overflow-hidden">
      
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/orginly_background.png')" }}
      />

      {/* Dark overlay to reduce brightness */}
      <div className="absolute inset-0 bg-black/60" />

      {/* Actual content */}
      <div className="relative z-10 flex flex-col h-full">
        <NavigationHeader />

        <main className="flex-1 overflow-y-auto mt-[72px] custom-scrollbar">
          <HeroSection />
          <PortfolioGrid />
          <Footer />
        </main>
      </div>
    </div>
  );
}
